import { getAction, postAction, deleteAction, putAction } from '../http'

//order
export default {
  list(params = {}) {
    return getAction('/api/design/order/list',params);
  },
  add(params = {}) {
    return postAction('/api/design/order/add',params);
  },
  edit(params = {}) {
    return putAction('/api/design/order/edit',params);
  },
  delete(params = {}) {
    return deleteAction('/api/design/order/delete',params);
  }
}